import { t } from 'i18next';
// export const pricingOptions = [
//   { id: 1, name: t('WeeklyBilling'), val: 'weekly' },
//   { id: 2, name: t('MonthlyBilling'), val: 'monthly' },
//   { id: 2, name: t('YearlyBilling'), val: 'yearly' },
// ];

import {
  BasicPlanIcon,
  EverythingPlanIcon,
  GoldPlanIcon,
  GrowPlanIcon,
  OnDemandIcon,
  PlatinumIcon,
  ProPlanIcon,
  SilverPlanIcon,
  StartupIcon,
} from '../../assets/Icons/Pricing/pricingIcons';

export const pricingPlansY = [
  {
    icon: <OnDemandIcon />,
    planName: 'On Demand',
    price: '4¢',
    priceUnit: 'per minute/text',
    timeValue: 'no monthly fee',
    emailValue: '1K',
    perMinTextValue: '4.0¢',
    perNumberValue: '$5',
    isPopular: false,
  },
  {
    icon: <BasicPlanIcon />,
    planName: 'Basic',
    price: '$79',
    priceUnit: '/month',
    timeValue: '2.8K',
    emailValue: '3K',
    perMinTextValue: '3.5¢',
    perNumberValue: '$4',
    isPopular: false,
  },
  {
    icon: <StartupIcon />,
    planName: 'Startup',
    price: '$239',
    priceUnit: '/month',
    timeValue: '10K',
    emailValue: '6K',
    perMinTextValue: '3.0¢',
    perNumberValue: '$3',
    isPopular: false,
  },
  {
    icon: <GrowPlanIcon />,
    planName: 'Grow',
    price: '$719',
    priceUnit: '/month',
    timeValue: '36K',
    emailValue: '10K',
    perMinTextValue: '2.5¢',
    perNumberValue: '$2',
    isPopular: true,
  },
  {
    icon: <ProPlanIcon />,
    planName: 'Pro',
    price: '$1,199',
    priceUnit: '/month',
    timeValue: '75K',
    emailValue: '20K',
    perMinTextValue: '2.0¢',
    perNumberValue: '$1',
    isPopular: false,
  },
];
export const pricingPlansM = [
  {
    icon: <OnDemandIcon />,
    planName: 'On Demand',
    price: '5¢',
    priceUnit: 'per minute/text',
    timeValue: 'no monthly fee',
    emailValue: '1K',
    perMinTextValue: '4.0¢',
    perNumberValue: '$5',
    isPopular: false,
  },
  {
    icon: <BasicPlanIcon />,
    planName: 'Basic',
    price: '$99',
    priceUnit: '/month',
    timeValue: '2.8K',
    emailValue: '3K',
    perMinTextValue: '3.5¢',
    perNumberValue: '$4',
    isPopular: false,
  },
  {
    icon: <StartupIcon />,
    planName: 'Startup',
    price: '$299',
    priceUnit: '/month',
    timeValue: '10K',
    emailValue: '6K',
    perMinTextValue: '3.0¢',
    perNumberValue: '$3',
    isPopular: false,
  },
  {
    icon: <GrowPlanIcon />,
    planName: 'Grow',
    price: '$899',
    priceUnit: '/month',
    timeValue: '36K',
    emailValue: '10K',
    perMinTextValue: '2.5¢',
    perNumberValue: '$2',
    isPopular: true,
  },
  {
    icon: <ProPlanIcon />,
    planName: 'Pro',
    price: '$1,499',
    priceUnit: '/month',
    timeValue: '75K',
    emailValue: '20K',
    perMinTextValue: '2.0¢',
    perNumberValue: '$1',
    isPopular: false,
  },
];
export const pricingPlansW = [
  {
    icon: <OnDemandIcon />,
    planName: 'On Demand',
    price: '4¢',
    priceUnit: 'per minute/text',
    timeValue: 'no weekly fee',
    emailValue: '250',
    perMinTextValue: '4.0¢',
    perNumberValue: '$5',
    isPopular: false,
  },
  {
    icon: <BasicPlanIcon />,
    planName: 'Basic',
    price: '$23',
    priceUnit: '/week',
    timeValue: '653',
    emailValue: '750',
    perMinTextValue: '3.5¢',
    perNumberValue: '$4',
    isPopular: false,
  },
  {
    icon: <StartupIcon />,
    planName: 'Startup',
    price: '$69',
    priceUnit: '/week',
    timeValue: '2.3K',
    emailValue: '1.5K',
    perMinTextValue: '3.0¢',
    perNumberValue: '$3',
    isPopular: false,
  },
  {
    icon: <GrowPlanIcon />,
    planName: 'Grow',
    price: '$207',
    priceUnit: '/week',
    timeValue: '8.3K',
    emailValue: '2.5K',
    perMinTextValue: '2.5¢',
    perNumberValue: '$2',
    isPopular: true,
  },
  {
    icon: <ProPlanIcon />,
    planName: 'Pro',
    price: '$346',
    priceUnit: '/week',
    timeValue: '17.3K',
    emailValue: '5K',
    perMinTextValue: '2.0¢',
    perNumberValue: '$1',
    isPopular: false,
  },
];
export const HighVolumePlansY = [
  {
    icon: <SilverPlanIcon />,
    planName: 'Silver',
    price: '$2,000',
    priceUnit: '/month',
    timeValue: '156K',
    emailValue: '50K',
    perMinTextValue: '1.6¢',
    perNumberValue: '$0.8',
    isPopular: false,
  },
  {
    icon: <GoldPlanIcon />,
    planName: 'Gold',
    price: '$4,800',
    priceUnit: '/month',
    timeValue: '500K',
    emailValue: '150K',
    perMinTextValue: '1.2¢',
    perNumberValue: '$0.7',
    isPopular: true,
  },
  {
    icon: <PlatinumIcon />,
    planName: 'Platinum',
    price: '$9,600',
    priceUnit: '/month',
    timeValue: '1.2M',
    emailValue: '400K',
    perMinTextValue: '1.0¢',
    perNumberValue: '$0.6',
    isPopular: false,
  },
  {
    icon: <EverythingPlanIcon />,
    planName: 'Everything',
    price: '$16,000',
    priceUnit: '/month',
    timeValue: '4M',
    emailValue: '1M',
    perMinTextValue: '0.5¢',
    perNumberValue: '$0.5',
    isPopular: false,
  },
];
export const HighVolumePlansM = [
  {
    icon: <SilverPlanIcon />,
    planName: 'Silver',
    price: '$2,500',
    priceUnit: '/month',
    timeValue: '156K',
    emailValue: '50K',
    perMinTextValue: '1.6¢',
    perNumberValue: '$0.8',
    isPopular: false,
  },
  {
    icon: <GoldPlanIcon />,
    planName: 'Gold',
    price: '$6,000',
    priceUnit: '/month',
    timeValue: '500K',
    emailValue: '150k',
    perMinTextValue: '1.2¢',
    perNumberValue: '$0.7',
    isPopular: true,
  },
  {
    icon: <PlatinumIcon />,
    planName: 'Platinum',
    price: '$12,000',
    priceUnit: '/month',
    timeValue: '1.2M',
    emailValue: '400k',
    perMinTextValue: '1.0¢',
    perNumberValue: '$0.6',
    isPopular: false,
  },
  {
    icon: <EverythingPlanIcon />,
    planName: 'Everything',
    price: '$20,000',
    priceUnit: '/month',
    timeValue: '4M',
    emailValue: '1M',
    perMinTextValue: '0.5¢',
    perNumberValue: '$0.5',
    isPopular: false,
  },
];
export const HighVolumePlansW = [
  {
    icon: <SilverPlanIcon />,
    planName: 'Silver',
    price: '$577',
    priceUnit: '/week',
    timeValue: '36K',
    emailValue: '12.5K',
    perMinTextValue: '1.6¢',
    perNumberValue: '$0.8',
    isPopular: false,
  },
  {
    icon: <GoldPlanIcon />,
    planName: 'Gold',
    price: '$1,385',
    priceUnit: '/week',
    timeValue: '115.4K',
    emailValue: '37.5K',
    perMinTextValue: '1.2¢',
    perNumberValue: '$0.7',
    isPopular: true,
  },
  {
    icon: <PlatinumIcon />,
    planName: 'Platinum',
    price: '$2,769',
    priceUnit: '/week',
    timeValue: '277K',
    emailValue: '100K',
    perMinTextValue: '1.0¢',
    perNumberValue: '$0.6',
    isPopular: false,
  },
  {
    icon: <EverythingPlanIcon />,
    planName: 'Everything',
    price: '$4,615',
    priceUnit: '/week',
    timeValue: '923K',
    emailValue: '250K',
    perMinTextValue: '0.5¢',
    perNumberValue: '$0.5',
    isPopular: false,
  },
];

export const industryList = [
  { value: "ACCOUNTING", name: "Accounting" },
  { value: "AIRLINES_AVIATION", name: "Airlines/Aviation" },
  {
    value: "ALTERNATIVE_DISPUTE_RESOLUTION",
    name: "Alternative Dispute Resolution",
  },
  { value: "ALTERNATIVE_MEDICINE", name: "Alternative Medicine" },
  { value: "ANIMATION", name: "Animation" },
  { value: "APPAREL_FASHION", name: "Apparel & Fashion" },
  { value: "ARCHITECTURE_PLANNING", name: "Architecture & Planning" },
  { value: "ARTS_AND_CRAFTS", name: "Arts and Crafts" },
  { value: "AUTOMOTIVE", name: "Automotive" },
  { value: "AVIATION_AEROSPACE", name: "Aviation & Aerospace" },
  { value: "BANKING", name: "Banking" },
  { value: "BIOTECHNOLOGY", name: "Biotechnology" },
  { value: "BROADCAST_MEDIA", name: "Broadcast Media" },
  { value: "BUILDING_MATERIALS", name: "Building Materials" },
  {
    value: "BUSINESS_SUPPLIES_AND_EQUIPMENT",
    name: "Business Supplies and Equipment",
  },
  { value: "CAPITAL_MARKETS", name: "Capital Markets" },
  { value: "CHEMICALS", name: "Chemicals" },
  {
    value: "CIVIC_SOCIAL_ORGANIZATION",
    name: "Civic & Social Organization",
  },
  { value: "CIVIL_ENGINEERING", name: "Civil Engineering" },
  { value: "COMMERCIAL_REAL_ESTATE", name: "Commercial Real Estate" },
  {
    value: "COMPUTER_NETWORK_SECURITY",
    name: "Computer & Network Security",
  },
  { value: "COMPUTER_GAMES", name: "Computer Games" },
  { value: "COMPUTER_HARDWARE", name: "Computer Hardware" },
  { value: "COMPUTER_NETWORKING", name: "Computer Networking" },
  { value: "COMPUTER_SOFTWARE", name: "Computer Software" },
  { value: "INTERNET", name: "Internet" },
  { value: "CONSTRUCTION", name: "Construction" },
  { value: "CONSUMER_ELECTRONICS", name: "Consumer Electronics" },
  { value: "CONSUMER_GOODS", name: "Consumer Goods" },
  { value: "CONSUMER_SERVICES", name: "Consumer Services" },
  { value: "COSMETICS", name: "Cosmetics" },
  { value: "DAIRY", name: "Dairy" },
  { value: "DEFENSE_SPACE", name: "Defense & Space" },
  { value: "DESIGN", name: "Design" },
  { value: "EDUCATION_MANAGEMENT", name: "Education Management" },
  { value: "E_LEARNING", name: "E-Learning" },
  {
    value: "ELECTRICAL_ELECTRONIC_MANUFACTURING",
    name: "Electrical/Electronic Manufacturing",
  },
  { value: "ENTERTAINMENT", name: "Entertainment" },
  { value: "ENVIRONMENTAL_SERVICES", name: "Environmental Services" },
  { value: "EVENTS_SERVICES", name: "Events Services" },
  { value: "EXECUTIVE_OFFICE", name: "Executive Office" },
  { value: "FACILITIES_SERVICES", name: "Facilities Services" },
  { value: "FARMING", name: "Farming" },
  { value: "FINANCIAL_SERVICES", name: "Financial Services" },
  { value: "FINE_ART", name: "Fine Art" },
  { value: "FISHERY", name: "Fishery" },
  { value: "FOOD_BEVERAGES", name: "Food & Beverages" },
  { value: "FOOD_PRODUCTION", name: "Food Production" },
  { value: "FUND_RAISING", name: "Fund-Raising" },
  { value: "FURNITURE", name: "Furniture" },
  { value: "GAMBLING_CASINOS", name: "Gambling & Casinos" },
  { value: "GLASS_CERAMICS_CONCRETE", name: "Glass, Ceramics & Concrete" },
  { value: "GOVERNMENT_ADMINISTRATION", name: "Government Administration" },
  { value: "GOVERNMENT_RELATIONS", name: "Government Relations" },
  { value: "GRAPHIC_DESIGN", name: "Graphic Design" },
  {
    value: "HEALTH_WELLNESS_AND_FITNESS",
    name: "Health, Wellness and Fitness",
  },
  { value: "HIGHER_EDUCATION", name: "Higher Education" },
  { value: "HOSPITAL_HEALTH_CARE", name: "Hospital & Health Care" },
  { value: "HOSPITALITY", name: "Hospitality" },
  { value: "HUMAN_RESOURCES", name: "Human Resources" },
  { value: "IMPORT_AND_EXPORT", name: "Import and Export" },
  {
    value: "INDIVIDUAL_FAMILY_SERVICES",
    name: "Individual & Family Services",
  },
  { value: "INDUSTRIAL_AUTOMATION", name: "Industrial Automation" },
  { value: "INFORMATION_SERVICES", name: "Information Services" },
  {
    value: "INFORMATION_TECHNOLOGY_AND_SERVICES",
    name: "Information Technology and Services",
  },
  { value: "INSURANCE", name: "Insurance" },
  { value: "INTERNATIONAL_AFFAIRS", name: "International Affairs" },
  {
    value: "INTERNATIONAL_TRADE_AND_DEVELOPMENT",
    name: "International Trade and Development",
  },
  { value: "INVESTMENT_BANKING", name: "Investment Banking" },
  { value: "INVESTMENT_MANAGEMENT", name: "Investment Management" },
  { value: "JUDICIARY", name: "Judiciary" },
  { value: "LAW_ENFORCEMENT", name: "Law Enforcement" },
  { value: "LAW_PRACTICE", name: "Law Practice" },
  { value: "LEGAL_SERVICES", name: "Legal Services" },
  { value: "LEGISLATIVE_OFFICE", name: "Legislative Office" },
  { value: "LEISURE_TRAVEL_TOURISM", name: "Leisure, Travel & Tourism" },
  { value: "LIBRARIES", name: "Libraries" },
  { value: "LOGISTICS_AND_SUPPLY_CHAIN", name: "Logistics and Supply Chain" },
  { value: "LUXURY_GOODS_JEWELRY", name: "Luxury Goods & Jewelry" },
  { value: "MACHINERY", name: "Machinery" },
  { value: "MANAGEMENT_CONSULTING", name: "Management Consulting" },
  { value: "MARITIME", name: "Maritime" },
  { value: "MARKET_RESEARCH", name: "Market Research" },
  { value: "MARKETING_AND_ADVERTISING", name: "Marketing and Advertising" },
  {
    value: "MECHANICAL_OR_INDUSTRIAL_ENGINEERING",
    name: "Mechanical or Industrial Engineering",
  },
  { value: "MEDIA_PRODUCTION", name: "Media Production" },
  { value: "MEDICAL_DEVICES", name: "Medical Devices" },
  { value: "MEDICAL_PRACTICE", name: "Medical Practice" },
  { value: "MENTAL_HEALTH_CARE", name: "Mental Health Care" },
  { value: "MILITARY", name: "Military" },
  { value: "MINING_METALS", name: "Mining & Metals" },
  { value: "MOTION_PICTURES_AND_FILM", name: "Motion Pictures and Film" },
  { value: "MUSEUMS_AND_INSTITUTIONS", name: "Museums and Institutions" },
  { value: "MUSIC", name: "Music" },
  { value: "NANOTECHNOLOGY", name: "Nanotechnology" },
  { value: "NEWSPAPERS", name: "Newspapers" },
  {
    value: "NON_PROFIT_ORGANIZATION_MANAGEMENT",
    name: "Nonprofit Organization Management",
  },
  { value: "OIL_ENERGY", name: "Oil & Energy" },
  { value: "ONLINE_MEDIA", name: "Online Media" },
  { value: "OUTSOURCING_OFFSHORING", name: "Outsourcing/Offshoring" },
  { value: "PACKAGE_FREIGHT_DELIVERY", name: "Package/Freight Delivery" },
  { value: "PACKAGING_AND_CONTAINERS", name: "Packaging and Containers" },
  { value: "PAPER_FOREST_PRODUCTS", name: "Paper & Forest Products" },
  { value: "PERFORMING_ARTS", name: "Performing Arts" },
  { value: "PHARMACEUTICALS", name: "Pharmaceuticals" },
  { value: "PHILANTHROPY", name: "Philanthropy" },
  { value: "PHOTOGRAPHY", name: "Photography" },
  { value: "PLASTICS", name: "Plastics" },
  { value: "POLITICAL_ORGANIZATION", name: "Political Organization" },
  { value: "PRIMARY_SECONDARY_EDUCATION", name: "Primary/Secondary Education" },
  { value: "PRINTING", name: "Printing" },
  {
    value: "PROFESSIONAL_TRAINING_COACHING",
    name: "Professional Training & Coaching",
  },
  { value: "PROGRAM_DEVELOPMENT", name: "Program Development" },
  { value: "PUBLIC_POLICY", name: "Public Policy" },
  {
    value: "PUBLIC_RELATIONS_AND_COMMUNICATIONS",
    name: "Public Relations and Communications",
  },
  { value: "PUBLIC_SAFETY", name: "Public Safety" },
  { value: "PUBLISHING", name: "Publishing" },
  { value: "RAILROAD_MANUFACTURE", name: "Railroad Manufacture" },
  { value: "RANCHING", name: "Ranching" },
  { value: "REAL_ESTATE", name: "Real Estate" },
  {
    value: "RECREATIONAL_FACILITIES_AND_SERVICES",
    name: "Recreational Facilities and Services",
  },
  { value: "RELIGIOUS_INSTITUTIONS", name: "Religious Institutions" },
  { value: "RENEWABLES_ENVIRONMENT", name: "Renewables & Environment" },
  { value: "RESEARCH", name: "Research" },
  { value: "RESTAURANTS", name: "Restaurants" },
  { value: "RETAIL", name: "Retail" },
  { value: "SECURITY_AND_INVESTIGATIONS", name: "Security and Investigations" },
  { value: "SEMICONDUCTORS", name: "Semiconductors" },
  { value: "SHIPBUILDING", name: "Shipbuilding" },
  { value: "SPORTING_GOODS", name: "Sporting Goods" },
  { value: "SPORTS", name: "Sports" },
  { value: "STAFFING_AND_RECRUITING", name: "Staffing and Recruiting" },
  { value: "SUPERMARKETS", name: "Supermarkets" },
  { value: "TELECOMMUNICATIONS", name: "Telecommunications" },
  { value: "TEXTILES", name: "Textiles" },
  { value: "THINK_TANKS", name: "Think Tanks" },
  { value: "TOBACCO", name: "Tobacco" },
  {
    value: "TRANSLATION_AND_LOCALIZATION",
    name: "Translation and Localization",
  },
  {
    value: "TRANSPORTATION_TRUCKING_RAILROAD",
    name: "Transportation/Trucking/Railroad",
  },
  { value: "UTILITIES", name: "Utilities" },
  {
    value: "VENTURE_CAPITAL_PRIVATE_EQUITY",
    name: "Venture Capital & Private Equity",
  },
  { value: "VETERINARY", name: "Veterinary" },
  { value: "WAREHOUSING", name: "Warehousing" },
  { value: "WHOLESALE", name: "Wholesale" },
  { value: "WINE_AND_SPIRITS", name: "Wine and Spirits" },
  { value: "WIRELESS", name: "Wireless" },
  { value: "WRITING_AND_EDITING", name: "Writing and Editing" },
  { value: "Software Development", name: "Software Development" },
  { value: "Collections", name: "Collections" },
  { value: "Legal", name: "Legal" },
  { value: "Education", name: "Education" },
  { value: "Finance", name: "Finance" },
  { value: "Credit Card Collections", name: "Credit Card Collections" },
  { value: "Computer Services", name: "Computer Services" },
  { value: "Contact Center Solutions", name: "Contact Center Solutions" },
  { value: "Marketing", name: "Marketing" },
  {
    value: "Office and Administrative Services",
    name: "Office and Administrative Services",
  },
]

